import type { PlatformLotteryDraw } from './platformLotteryDrawTypes';

const PREFIX = 'alea.platformDraws.v1:';
const MAX_CHARS = 400_000;

function drawTurnKey(row: PlatformLotteryDraw): string {
  return `${row.source}:${row.dayKey}:${row.window}`;
}

/**
 * A 2–4 doc Hoy unary must not wipe Esta semana rows already painted
 * (Safari / Listen often never delivers the live cap).
 */
export function mergePreferRicherDraws(
  prev: PlatformLotteryDraw[],
  next: PlatformLotteryDraw[],
): PlatformLotteryDraw[] {
  if (next.length === 0) return prev;
  const byKey = new Map<string, PlatformLotteryDraw>();
  for (const row of prev) byKey.set(drawTurnKey(row), row);
  for (const row of next) byKey.set(drawTurnKey(row), row);
  const nextKeys = new Set(next.map(drawTurnKey));
  const prevOnly = prev.filter((row) => !nextKeys.has(drawTurnKey(row)));
  if (prevOnly.length === 0) return next;
  return [...byKey.values()].sort((a, b) => {
    if (a.dayKey !== b.dayKey) return a.dayKey < b.dayKey ? 1 : -1;
    if (a.window === b.window) return 0;
    return a.window === 'day' ? -1 : 1;
  });
}

export function platformDrawsCacheKey(source: string): string {
  return `${PREFIX}${source}`;
}

export function readPlatformDrawsCache(source: string): PlatformLotteryDraw[] {
  try {
    const raw = sessionStorage.getItem(platformDrawsCacheKey(source));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed as PlatformLotteryDraw[] : [];
  } catch {
    return [];
  }
}

export function writePlatformDrawsCache(source: string, rows: PlatformLotteryDraw[]): void {
  try {
    const raw = JSON.stringify(rows);
    if (raw.length > MAX_CHARS) return;
    sessionStorage.setItem(platformDrawsCacheKey(source), raw);
  } catch {
    /* quota / private mode */
  }
}
